import React, { PropTypes } from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import RecentlyReturnedEmptyContentPanel from '../components/borrowing/recentlyreturned/RecentlyReturnedEmptyContentPanel';
import { bindActionCreators } from 'redux';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import ListPresentationActions from '../actions/ListPresentationActions';
import * as AccountActions from '../actions/AccountActions';
import { currentAccountSelector, currentUserSelector } from '../selectors/AuthSelector';
import * as BorrowingActions from '../actions/BorrowingActions';
import * as RecentlyReturnedActions from '../actions/RecentlyReturnedActions';
import RecentlyReturned from '../components/borrowing/recentlyreturned/RecentlyReturned';
import NotFound from '@bibliocommons/not-found';
import { currentLibrarySelector } from '../selectors/LibrarySelector';
import { getRecentlyReturnedWithBibs, getBorrowingHistoryData } from '../selectors/RecentlyReturnedSelector';
import RatingsActions from '../actions/RatingsActions';
import { getRatingsTransactions, getRatingsByBibs } from '../selectors/ugc/RatingsSelector';
import WorkflowActions from '../actions/WorkflowActions';
import { getCurrentView } from '../selectors/ListPresentationSelector';
import ShelfActions from '../actions/ShelfActions';
import RecentlyReturnedLoading from '../components/borrowing/recentlyreturned/RecentlyReturnedLoading';
import DocumentHeadContainer from './DocumentHeadContainer';
import BasePageContainer from './BasePageContainer';

export class RecentlyReturnedContainer extends BasePageContainer {

  static fetchInitialData(params, query, store) {
    const account = currentAccountSelector(store.getState());
    const accountId = account && account.get('id');

    return [
      store.dispatch(BorrowingActions.fetchSummaries({ accountId })),
      store.dispatch(RecentlyReturnedActions.fetchReturnHistory({ ...params, ...query, accountId }))
    ];
  }

  static getBackToTitleKey() {
    return 'borrowing_history';
  }

  componentDidMount() {
    super.componentDidMount();

    const { accountId, location } = this.props;
    this.props.RecentlyReturnedActions.fetchReturnHistory({ ...location.query, accountId });
  }

  componentWillReceiveProps(nextProps) {
    const { location, accountId } = this.props;
    const { location: nextLocation } = nextProps;
    if (this.interval && nextProps.sortOptions) {
      clearInterval(this.interval);
      this.interval = false;
    }

    if ((location !== nextLocation)) {
      this.props.RecentlyReturnedActions.fetchReturnHistory({ ...nextLocation.query, accountId });
    }
  }

  retryLoading() {
    const { accountId } = this.props;
    this.props.RecentlyReturnedActions.fetchReturnHistory({ ...this.props.router.location.query, accountId });
  }


  render() {
    const pageTitle = this.props.intl.formatMessage({ id: 'section_title_recently_returned' });
    if (!this.props.items || this.props.items.size === 0) {
      if (this.props.isFetching ||
        (this.props.sortOptions && this.props.recentlyReturnedSupported && this.props.saveBorrowingHistoryEnabled)) {
        return <RecentlyReturnedEmptyContentPanel fetching={this.props.isFetching} />;
      }
    }
    if (!this.interval && !this.props.isFetching && !this.props.sortOptions && this.props.recentlyReturnedSupported && this.props.saveBorrowingHistoryEnabled) {
      this.interval = setInterval(() => {
        this.retryLoading();
      }, 5000);
    }
    if (!this.props.sortOptions && this.props.recentlyReturnedSupported && this.props.saveBorrowingHistoryEnabled) {
      return (
        <RecentlyReturnedLoading retryLoading={this.retryLoading} isLoading={this.props.isFetching} />
      );
    }

    return (
      <div>
        <DocumentHeadContainer pageTitle={pageTitle} />
        { this.props.recentlyReturnedSupported ?
          <RecentlyReturned {...this.props} /> :
          <NotFound /> }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  RecentlyReturnedActions: bindActionCreators(RecentlyReturnedActions, dispatch),
  workflowActions: bindActionCreators(WorkflowActions, dispatch),
  listPresentationActions: bindActionCreators(ListPresentationActions, dispatch),
  accountActions: bindActionCreators(AccountActions, dispatch),
  shelfActions: bindActionCreators(ShelfActions, dispatch),
  ratingsActions: bindActionCreators(RatingsActions, dispatch)
});

const mapStateToProps = (state, ownProps) => {
  const library = currentLibrarySelector(state);
  const recentlyReturnedSupported = library.get('recentlyReturned');
  const user = currentUserSelector(state);
  const accountId = currentAccountSelector(state).get('id').toString();
  const saveBorrowingHistoryEnabled = currentAccountSelector(state).get('borrowingHistoryEnabled');
  const items = getRecentlyReturnedWithBibs(state, ownProps);
  const ilsProperties = Immutable.Map({
    supportsBorrowingHistory: library.get('supportsBorrowingHistory', false),
    borrowingHistorySupportsReturnedDates: library.get('borrowingHistorySupportsReturnedDates', false),
    maintainsBorrowingHistoryOnDisable: library.get('maintainsBorrowingHistoryOnDisable', false)
  });
  const currentView = getCurrentView(state, ownProps);
  const borrowingHistoryData = getBorrowingHistoryData(state);
  const recentlyReturnedPaging = borrowingHistoryData.get('pagination', Immutable.Map());
  const returnedItemsOnLastDate = borrowingHistoryData.get('returnedItemsOnLastDate');
  const sortOptions = borrowingHistoryData.get('sortOptions');
  const isFetching = borrowingHistoryData.get('isFetching');

  const ratingsTransactions = getRatingsTransactions(state);
  const ratings = getRatingsByBibs(state);

  return {
    user,
    recentlyReturnedSupported,
    saveBorrowingHistoryEnabled,
    recentlyReturnedPaging,
    ilsProperties,
    items,
    isFetching,
    currentView,
    sortOptions,
    returnedItemsOnLastDate,
    accountId,
    ratings,
    ratingsTransactions
  };
};

RecentlyReturnedContainer.propTypes = {
  intl: intlShape,
  ratingsTransactions: ImmutablePropTypes.map,
  accountId: PropTypes.number
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RecentlyReturnedContainer));



// WEBPACK FOOTER //
// ./app/containers/RecentlyReturnedContainer.jsx